import { render, staticRenderFns } from "./ownerExitRoom.vue?vue&type=template&id=eddf9452&scoped=true"
import script from "./ownerExitRoom.vue?vue&type=script&lang=js"
export * from "./ownerExitRoom.vue?vue&type=script&lang=js"
import style0 from "./ownerExitRoom.vue?vue&type=style&index=0&id=eddf9452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddf9452",
  null
  
)

export default component.exports